import React from 'react';

import { ToggleSwitch } from 'components/ToggleSwitch';
import { StyledBorderedPaper } from 'styles/common';

import { Bullet2SvgIcon, List2SvgIcon } from 'constants/icons';
import theme from 'constants/theme';

const CONTENT_TYPES = {
  PARAGRAPH: {
    id: 'PARAGRAPH',
    title: 'Paragraph',
    icon: <List2SvgIcon color={theme.palette.icons.blackv1} size="fixed12px" />,
    tooltipText: 'Paragraph Description',
  },
  BULLETS: {
    id: 'BULLETS',
    title: 'Bullets',
    icon: <Bullet2SvgIcon color={theme.palette.icons.blackv1} size="fixed12px" />,
    tooltipText: 'Bullet points Description',
  },
};

const DimensionContentType = ({ contentType, onChange, isVisible = false }) => {
  const handleContentTypeChange = (contentTypeId) => {
    onChange(contentTypeId);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <StyledBorderedPaper style={{ borderTop: 'none', borderLeft: 'none' }}>
      <ToggleSwitch
        selectedId={contentType}
        onIconClick={handleContentTypeChange}
        iconsList={Object.values(CONTENT_TYPES)}
        bgcolor={theme.palette.background.paper}
      />
    </StyledBorderedPaper>
  );
};

// const ToggleButton = styled(NewStyledIconButton)`
//   padding: 0.375rem 1rem;
//   border-radius: 4px;
//   color: ${props => props.theme.palette.text.secondary} !important;

//   ${props =>
//     props.selected &&
//     css`
//       background-color: white;
//       color: ${props.theme.palette.primary.main} !important;

//       svg {
//         fill: ${props.theme.palette.primary.main} !important;
//       }
//     `};

//   ${props =>
//     props.disabled &&
//     css`
//       svg {
//         fill: ${props.theme.palette.icons.grey} !important;
//       }
//     `};

//   pointer-events: auto !important;
// `;

export default DimensionContentType;
